import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_blue_header/payer-acompte/legacy')({
  validateSearch: z.object({
    email: z.string().optional(),
    lastName: z.string().optional(),
    dossierNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/payer-acompte/ancien', search, replace: true })
  },
})
